import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { Injector, Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { tap } from '../../../../node_modules/rxjs/operators';
import { Observable } from '../../../../node_modules/rxjs';
import { AauditProcess } from '../entities/aaudit-process';
import { AauditProcessResult } from '../model/aaudit-process-result';

@Injectable()
export class AauditProcessService extends BaseCrudService<AauditProcess> {

    public uri = '/api/aauditProcess/';

    constructor(injector: Injector) {
        super(injector);
    //    console.log('Instance AauditProcessService');
    }

    buildSentence(entity?: AauditProcess, event?: LazyLoadEvent): HttpParams {
    if (entity) {
        let query = '';
        if (entity.process && entity.process.id) {
            query = query.concat(
                `process.id${QueryOperator.Equal}${entity.process.id}${QueryOperator.Split}`
            );
        }

        this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
        const page = ((event.first + event.rows) / event.rows - 1).toString();
        const size = event.rows.toString();
        this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
        this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        
        this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);

    }
    let sortOrder = 'desc';
    this.httpParams =  this.httpParams.set(QueryOperator.SortParam, `id,${sortOrder}`);


    return this.httpParams;
    }

    finishedProcess(code: string, processCode: string): Observable<AauditProcessResult> {
        const url = `${this.rutaServidor}${this.uri}finishedProcess/${code}/${processCode}`;
        // this.spinnerService.showAll();
        return this.httpClient
          .get<AauditProcessResult>(url)
          .pipe(
            tap(response => {
            //  console.log(response);
            //   this.spinnerService.hideAll();
              return response;
            })
          );
    }
}




// WEBPACK FOOTER //
// ./src/app/core/services/aaudit-process.service.ts